module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.1dc35d2.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.6.3
// module id = 779
// module chunks = 2